import { click } from 'ol/events/condition';
import Draw from 'ol/interaction/Draw';
import Select from 'ol/interaction/Select';
import { measureDrawLayer, validatedParcelLayer } from '@/ol/layers';
import { getSelectValidatedParcelleStyle, measureDrawStyle } from '@/ol/styles';

export const selectValidatedParcelle = new Select({
  layers: [validatedParcelLayer],
  multi: true,
  condition: click,
  addCondition: click,
  removeCondition: click,
  style: (feature) => getSelectValidatedParcelleStyle(feature),
});

export const measureDrawLength = new Draw({
  source: measureDrawLayer.getSource(),
  type: 'LineString',
  style: measureDrawStyle,
  stopClick: true,
});

export const measureDrawArea = new Draw({
  source: measureDrawLayer.getSource(),
  type: 'Polygon',
  style: measureDrawStyle,
  stopClick: true,
});
